import React, { Component } from 'react';
import { WidgetHelper } from '../WidgetHelper';

interface IFondsRebondSuccessWidgetProps {
    isSuccess: number;
    dictSuccessText: string;
    dictSuccessContact1: string;
    dictSuccessContact2: string;
    dictSuccessMail: string;
    dictSuccessPhone: string;
    dictSuccessSignature1: string;
    dictSuccessSignature2: string;
    dictFailLabel: string;
    dictRetryLabel: string;
    retryFunc: () => void;
}

export class FondsRebondSuccessWidget extends Component<IFondsRebondSuccessWidgetProps> {
    constructor(props: IFondsRebondSuccessWidgetProps) {
        super(props);
        this.state = {};
    }

    render() {
        const borderRadius = {
            borderRadius: '100%',
        } as React.CSSProperties;
        const borderRadiusBig = {
            borderRadius: '100%',
            fontSize: '150%',
        } as React.CSSProperties;

        const phoneLink = 'tel:' + this.props.dictSuccessPhone;
        const mailLink =
            'mailto:' +
            this.props.dictSuccessMail +
            '?subject=Question/Vraag faillites/n';

        if (this.props.isSuccess === 1) {
            return (
                <div className="container">
                    <div className="row mb-4">
                        <div className="offset-5 col-2 text-center">
                            <i
                                className="icon-check alert-success p-3"
                                style={borderRadius}
                            ></i>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="offset-3 col-6 text-center">
                            {this.props.dictSuccessText}
                        </div>
                    </div>
                    <div className="row mb-5">
                        <div className="offset-3 col-6 text-center">
                            {this.props.dictSuccessContact1}{' '}
                            <a href={phoneLink}>
                                {this.props.dictSuccessPhone}
                            </a>{' '}
                            {this.props.dictSuccessContact2}{' '}
                            <a href={mailLink}>{this.props.dictSuccessMail}</a>
                        </div>
                    </div>
                    <div className="row">
                        <div className="offset-3 col-6 text-center">
                            {this.props.dictSuccessSignature1}
                            <br />
                            <strong>{this.props.dictSuccessSignature2} </strong>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="container">
                    <div className="row mb-4">
                        <div className="offset-5 col-2 text-center">
                            <i
                                className="icon-warning alert-danger p-3"
                                style={borderRadiusBig}
                            ></i>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="offset-3 col-6 text-center">
                            {this.props.dictFailLabel}
                        </div>
                    </div>
                    <div className="row">
                        <div className="offset-3 col-6 text-center">
                            <button onClick={this.props.retryFunc}>
                                <i className="icon-angleTop"></i>
                                {this.props.dictRetryLabel}
                            </button>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

WidgetHelper.register(FondsRebondSuccessWidget, 'fonds-rebond-success-widget');
